import { useEffect, useState } from 'react';
import styles from './InviteModal.module.css';
import EmptyModal from '../../compoenets/EmptyModal';
import useApi from '../../services/useApi';
import { namespaceState,namespaceDetailState } from '../../recoil/atoms';
import { useRecoilState } from 'recoil';
import searchValue from '../../utils/searchValue';
import Dropdown from '../../compoenets/Dropdown';
import toUpperFirstCase from '../../utils/toUpperFirstCase';
import SearchBar from '../../compoenets/SearchBar';

const SelectedItem=({data,onRemove})=>{
    return(
        <div className={styles['item-wrap']}>
            <p className={styles['item-name']}>
                <span>{data.workspaceUserMail.split('@')[0]}</span>
                {/* <span>{data.workspaceUserMail}</span> */}
            </p>
            <div className={styles['item-role']}>{toUpperFirstCase(data.namespaceUserRoleName)}</div>
            <div className={styles['item-remove']} onClick={()=>onRemove(data)}></div>
        </div>
    )
}

const Row=({data,onAdd,onRoleChange,resetRole,onResetRole})=>{
    const [isAdd,setIsAdd]=useState(false);
    const [role,setRole]=useState(null);

    useEffect(()=>{
        setRole(data.namespaceUserRoleName)
    },[])

    useEffect(()=>{
        if(!resetRole)return;
        setIsAdd(false);
        setRole(null);
        onResetRole();
    },[resetRole])

    const handleBtn=()=>{
        onAdd(data);
        setIsAdd(true);
        setRole("Member");
    }

    const handleRoleChange=(updatedRole)=>{
        setRole(updatedRole);
        onRoleChange(data,updatedRole);
    }

    return(
        <div className={styles['row-wrap']}>
            <p className={styles['row-name']}>
                <span>{data.workspaceUserMail.split('@')[0]}</span>
                <span>{data.workspaceUserMail}</span>
            </p>
            {/* :<div className={`${styles['row-btn']} ${isAdd && styles['row-dropdown']}`} onClick={handleBtn}>{isAdd?<Dropdown selected={"Member"} />:"+ Add"}</div> */}
            {data.namespaceUserRoleName?
            <div className={styles['row-role']}>{role}</div>
            :isAdd?<Dropdown selected={role} onChange={handleRoleChange} />
            :<div className={`${styles['row-btn']} ${isAdd && styles['row-dropdown']}`} onClick={handleBtn}>+ Add</div>
            }
        </div>
    )
}

export default function InviteModal({onRefreshList,onClose}){
    const [searchedUsers, setSearchedUsers] = useState([]);
    const [isList,setIsList]=useState(false);
    const [inputValue,setInputValue]=useState(null);
    const [isInputClear,setIsInputClear]=useState(false);
    const [isSearch,setIsSearch]=useState(false);
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [nsDetailState,setNsDetailState]=useRecoilState(namespaceDetailState);
    const [userList,setUserList]=useState([]);
    const [selectedUsers,setSelectedUsers]=useState([]);
    const [resetRow,setResetRow]=useState(null);

    useEffect(()=>{
        useApi.get('/ngp/namespace/user/not/list?namespaceId='+nsState.id).then((res)=>{
            setUserList(prevData=>([
                ...prevData,
                ...res.data
            ]));
        })
        useApi.get('/ngp/namespace/user/list?namespaceId='+nsState.id).then((res)=>{
            setUserList(prevData=>([
                ...prevData,
                ...res.data
            ]));
        })
    },[])

    const handleInputChange=(value)=>{
        if(value.trim()===""){
          setSearchedUsers([]);
          setIsList(false);
          return;
        }

        if(value.trim()!==""){
          setIsList(true);
        }

        setSearchedUsers(searchValue(userList,value));
    }

    const handleInputClear=()=>{
        setSearchedUsers([]);
        setIsList(false);
    }

    const handleAdd=(row)=>{
        if(!selectedUsers.find(selected=>selected.workspaceUserMail===row.workspaceUserMail)){
            const newRow = {...row,"namespaceUserRoleName":"member"};
            setSelectedUsers([...selectedUsers,newRow]);
        }
    }
    const handleRemove=(item)=>{
        setSelectedUsers(selectedUsers.filter(selected=>selected.workspaceUserMail!==item.workspaceUserMail));
        setResetRow(item.workspaceUserMail)
    }

    const handleRoleChange=(item,updatedRole)=>{
        setSelectedUsers(selectedUsers.map(selected=>selected.workspaceUserMail===item.workspaceUserMail?{...item,"namespaceUserRoleName":updatedRole}:selected))
    }

    const handleDone=()=>{
        const updatedUsers=selectedUsers.map(item=>{
            const role=nsDetailState.roleList.find(r=>r.name===item.namespaceUserRoleName);
            return{
                namespaceRoleId:role.id,
                workspaceUserId:item.workspaceUserId,
                namespaceUserDesc:item.workspaceUserMail+" "+role.name,
            }
        })

        useApi.post('ngp/namespace/user/pending/request/force?namespaceId='+nsState.id,{
            "requestList": updatedUsers
        }).then(res=>{
            onRefreshList();
            onClose();
        })
    }

    return(
        <EmptyModal
        onAction={()=>{}}
        onClose={()=>onClose()}>
            <div className={styles['main']}>
                <div className={styles['header']}>
                    <div className={styles['header-title']}>
                        {/* <div></div> */}
                        <span>Invite user</span>
                    </div>
                    <div className={styles['close']}onClick={onClose}></div>
                </div>
                <SearchBar
                placeholder='Search user id'
                onChange={handleInputChange} 
                onClear={handleInputClear}
                />
                <div className={styles['searched-list']}>
                    {searchedUsers.map((row) => (
                      <Row 
                      key={row.id} 
                      data={row} 
                      onAdd={handleAdd} 
                      onRoleChange={handleRoleChange}
                      resetRole={resetRow===row.workspaceUserMail}
                      onResetRole={()=>setResetRow(null)}
                      />
                    ))}
                </div>
                <hr></hr>
                <div className={styles['selected-list']}>
                    {selectedUsers.map((itemData) => (
                      <SelectedItem key={itemData.id} data={itemData} onRemove={handleRemove}/>
                    ))}
                </div>
                <div className={styles['footer']}>
                    <div className={styles['footer-clear']} onClick={()=>setSelectedUsers([])}>Clear users</div>
                    <div className={styles['footer-done']} onClick={handleDone}>Done</div>
                </div>
            </div>
        </EmptyModal>
    )
}